/**
 * Ralph & Doug characters: switches the hand-drawn figure animations on only while a figure
 * is on screen (.is-on on each [data-rd-fig]), and adds the three SVG displacement filters
 * that make the line work "boil" (rd-story.css, @keyframes rd-fig-boil) to the page once.
 */
(function () {
  'use strict';

  var SVG_NS = 'http://www.w3.org/2000/svg';
  var SEEDS = [3, 11, 27];

  var addFilters = function () {
    if (document.getElementById('rd-boil-1')) return;
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('width', '0');
    svg.setAttribute('height', '0');
    svg.style.position = 'absolute';
    SEEDS.forEach(function (seed, i) {
      var filter = document.createElementNS(SVG_NS, 'filter');
      filter.setAttribute('id', 'rd-boil-' + (i + 1));
      var noise = document.createElementNS(SVG_NS, 'feTurbulence');
      noise.setAttribute('type', 'fractalNoise');
      noise.setAttribute('baseFrequency', '0.035');
      noise.setAttribute('numOctaves', '2');
      noise.setAttribute('seed', String(seed));
      var map = document.createElementNS(SVG_NS, 'feDisplacementMap');
      map.setAttribute('in', 'SourceGraphic');
      map.setAttribute('scale', '2.4');
      map.setAttribute('xChannelSelector', 'R');
      map.setAttribute('yChannelSelector', 'G');
      filter.appendChild(noise);
      filter.appendChild(map);
      svg.appendChild(filter);
    });
    document.body.appendChild(svg);
  };

  var observer = null;
  var watch = function () {
    var figs = document.querySelectorAll('[data-rd-fig]:not([data-rd-fig-watched])');
    if (!figs.length) return;
    addFilters();
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(figs, function (f) {
        f.classList.add('is-on');
      });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          e.target.classList.toggle('is-on', e.isIntersecting);
        });
      });
    }
    Array.prototype.forEach.call(figs, function (f) {
      f.setAttribute('data-rd-fig-watched', '');
      observer.observe(f);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
  document.addEventListener('shopify:section:load', watch);
})();
